import { h } from "preact";

import Button from "./Button.jsx";
import i18n from "../i18n.js";
import { classNames } from "../helpers.js";

export default function TalentAdminActions({ onClick, ...props }) {
  return (
    <div class={classNames("talent-admin-actions mr-8", props.class)}>
      <span class="talent-admin-actions__label mr-4">Admin action:</span>

      <Button secondary small onClick={onClick}>
        {i18n.t("component.add_to_project_button.label")}
      </Button>
    </div>
  );
}
